module.exports = __webpack_public_path__ + "img/titlevi.09573af2.png";